namespace RedBullMOBILE360.PushNotifications {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.PushNotifications.PushNotificationsGrid')
    export class PushNotificationsGrid extends Serenity.EntityGrid<PushNotificationsRow, any> {
        protected getColumnsKey() { return PushNotificationsColumns.columnsKey; }
        protected getDialogType() { return PushNotificationsDialog; }
        protected getIdProperty() { return PushNotificationsRow.idProperty; }
        protected getInsertPermission() { return PushNotificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return PushNotificationsRow.localTextPrefix; }
        protected getService() { return PushNotificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import Custom Notifications',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new PushNotificationsExcelImportDialog();
                    dialog.dialogOpen();
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template',
                grid: this,
                service: PushNotificationsService.baseUrl + '/DownloadTemplate',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }
    }
}